const SIZE = {
  SMALL: "22px",
  MEDIUM: "26px",
  LARGE: "32px",
}

export default {
  SIZE
}